<template>
  <div id="app">
    <router-view />
    <ChatBot />
  </div>
</template>

<script>
import ChatBot from './components/ChatBot.vue'

export default {
  name: 'App',
  components: {
    ChatBot
  }
}
</script>

<style>
/* 全局基础样式 - 添加到App.vue以确保全局生效 */
html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden; /* 关键：防止横向滚动条出现 */
  width: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0; /* 移除顶部margin，让内容顶格显示 */
  width: 100%;
  overflow-x: hidden; /* 确保app容器也不会出现横向滚动 */
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  margin: 0 10px;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>